module.exports = __webpack_public_path__ + "img/业务介绍物业4.b641cb10.jpg";